import { render, staticRenderFns } from "./SalesMenu.vue?vue&type=template&id=224fcd7d"
import script from "./SalesMenu.vue?vue&type=script&lang=js"
export * from "./SalesMenu.vue?vue&type=script&lang=js"
import style0 from "./SalesMenu.vue?vue&type=style&index=0&id=224fcd7d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports